export class BBOX {
  south: number;
  west: number;
  north: number;
  east: number;

  constructor(south: number, west: number, north: number, east: number) {
    this.south = south;
    this.west = west;
    this.north = north;
    this.east = east;
  }

  toString(): string {
    return '' + this.south + this.west + this.north + this.east;
  }
}
